var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeach = function SvgBeach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_914_130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02.065a1 1 0 00-1.215.428L.138 11.826A1 1 0 001.3 13.287l7.927-2.493 3.226 8.455-5.396 2.868A1 1 0 007.527 24H21a1 1 0 00.41-1.912l-6.921-3.112-3.35-8.783L21.3 6.997a1 1 0 00.054-1.89L8.02.066zM11.54 22l2.2-1.169 2.6 1.17h-4.8zm-.72-18.738l4.737 3.445 2.387-.751-7.123-2.694zM3.18 10.599l2.41-4.097-.575 3.327a1 1 0 00-.015.198l-1.82.572zM7.254 8.62l.842-4.866 4.633 3.369L7.254 8.62z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_914_130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBeach;